import { Typography } from "@mui/material";
import theme from "../../../core/theme";
import SimpleTable from "../../../common/components/SimpleTable";
import {
	ChangeRequestBaseCard,
	ChangeRequestBaseCardProps,
} from "./ChangeRequestBaseCard";
import { useHorizonChanges } from "../../../common/hooks/useHandleHorizonChanges";
import Tabs, { SingleTab } from "../../../common/components/Tabs";
import { useMemo, useState } from "react";
import { camelToSpaceCase } from "../../../common/utils/camelToSpaceCase";

export const style = {
	body: {
		title: {
			fontFamily: theme.typography.fontFamily,
			fontSize: "20px",
			fontWeight: "600",
		},
	},
};

export const ChangeRequestHorizonChangeCard = ({
	changeRequest,
	...props
}: ChangeRequestBaseCardProps) => {
	const { entities, entitiesMap } = useHorizonChanges(
		changeRequest?.raw_json || []
	);
	const [currentTab, setCurrentTab] = useState("");

	const initialTab = useMemo(() => {
		if (entities) {
			return entities[0];
		}
	}, [entities]);

	return (
		<ChangeRequestBaseCard changeRequest={changeRequest} {...props}>
			<Typography sx={style.body.title}>Impacted elements</Typography>
			<Tabs
				activeTab={currentTab || initialTab || ""}
				label={""}
				onClickTabItem={(tab: string) => {
					setCurrentTab(tab);
				}}
			>
				{(entities || []).map((tab) => (
					<SingleTab
						key={tab}
						label={camelToSpaceCase(tab)}
						id={tab}
						isActive={tab === currentTab}
					/>
				))}
			</Tabs>
			<SimpleTable
				headers={[
					{ label: "Resource name", accessor: "target_name" },
					{ label: "Field name", accessor: "target_attribute_name" },
					{
						label: "Old value",
						accessor: "old_value",
						format: (value: any) =>
							typeof value === "object"
								? JSON.stringify(value)
								: value,
					},
					{
						label: "New value",
						accessor: "new_value",
						format: (value: any) =>
							typeof value === "object"
								? JSON.stringify(value)
								: value,
					},
				]}
				items={entitiesMap[currentTab || initialTab || ""] || []}
			/>
		</ChangeRequestBaseCard>
	);
};
